export const LOAD_LANGUAGE = 'LOAD_LANGUAGE';
export const LOAD_LANGUAGE_SUCCESS = 'LOAD_LANGUAGE_SUCCESS';

export const REDUCER_KEY_MESSAGE = 'intlMessage';
export const REDUCER_KEY_LANGUAGE = 'language';

export const DEFAULT_LANGUAGE = 'en';
